import { usePortalTheme } from '@/ui/components/portal-preview/use-portal-theme'
import { ReactElement } from 'react'

export interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactElement | string
}

// Component
export const Button: React.FC<ButtonProps> = ({ children }) => {
  const theme = usePortalTheme()
  return (
    <div
      className="flex w-full items-center justify-center border-none p-4 px-5 py-3 transition-all"
      style={{
        borderRadius: theme.borderRadius ?? '10rem',
        color: theme.colors?.primary?.contrastText ?? '#000',
        backgroundColor: theme.colors?.primary?.main ?? '#fff',
        textDecoration:
          theme?.colors?.primary?.main === 'transparent' ? 'underline' : 'none'
      }}
    >
      {children}
    </div>
  )
}

export default Button
